<div>
  <h2>{{ 'Senaste ordrar' | translate }}</h2>
  <table class="styled fullwidth">
    <tr>
      <th></th>
      <th>{{ 'Datum' | translate }}</th>
      <th>{{ 'Namn' | translate }}</th>
      <th>{{ 'Epost' | translate }}</th>
      <th>{{ 'Artiklar' | translate }}</th>
    </tr>
    <tr *ngFor="let order of orders">
      <td>#{{order.order_number}}</td>
      <td>{{ order.created_at | date: "yyyy-MM-dd HH:mm" }}</td>
      <td>{{ order.customer.first_name }} {{ order.customer.last_name }}</td>
      <td>{{ order.customer.email }}</td>
      <td>
        <div *ngFor="let lineItem of order.line_items">
          {{ lineItem.quantity }}x {{ lineItem.name }}
        </div>
      </td>
    </tr>
  </table>
</div>
